import httpClient from '../../httpClient';

function getDashboardMonthlyPlanMetrics(months) {
  return httpClient({
    url: `/boards/dashboard/monthly-plan-metrics${months ? `?months=${months}` : ''}`,
    method: 'GET',
  });
}

export default getDashboardMonthlyPlanMetrics;